// components
import ContentLayout from "@/layouts/ContentLayout";
import TextBlock from "@/components/blocks/TextBlock";

// assets
import TitleBanner from "@/components/banners/TitleBanner";
import banner from "@/assets/images/our-commitments/banner.png";
import affordableAndCleanEnergy from "@/assets/images/our-commitments/affordableAndCleanEnergy.png";
import responsibleConsumptionAndProduction from "@/assets/images/our-commitments/responsibleConsumptionAndProduction.png";
import climateAction from "@/assets/images/our-commitments/climateAction.png";
import goodHealthAndWellBeing from "@/assets/images/our-commitments/goodHealthAndWellBeing.png";
import lifeBelowWater from "@/assets/images/our-commitments/lifeBelowWater.png";
import lifeOnLand from "@/assets/images/our-commitments/lifeOnLand.png";

// i18n
import { useTranslation } from "react-i18next";

const OurCommitments = () => {
  const { t } = useTranslation();

  const direct = [affordableAndCleanEnergy, responsibleConsumptionAndProduction, climateAction];

  const indirect = [goodHealthAndWellBeing, lifeBelowWater, lifeOnLand];

  return (
    <div className="w-full">
      <TitleBanner bannerImg={banner} title={t("our_commitments.our_commitments")} />
      <ContentLayout>
        <article className="flex w-full flex-col gap-6">
          <TextBlock
            title={"sustainable_development_goals"}
            descriptions={[
              "sustainable_development_goals_description_1",
              "sustainable_development_goals_description_2",
              "sustainable_development_goals_description_3",
            ]}
            translationKey="our_commitments"
          />
          <div className="flex flex-wrap gap-x-9">
            <div className="flex flex-col flex-1 gap-y-6">
              <div className="text-2xl font-bold text-primary">{t("our_commitments.direct")}</div>
              <div className="flex flex-wrap justify-between gap-3">
                {direct.map((item) => (
                  <div key={item} className="flex max-w-[180px] items-center">
                  <img src={item} alt="direct" />
                </div>
              ))}
              </div>
            </div>
            <div className="flex flex-col flex-1 gap-y-6">
              <div className="text-2xl font-bold text-primary">{t("our_commitments.indirect")}</div>
              <div className="flex flex-wrap justify-between gap-3">
                {indirect.map((item) => (
                  <div key={item} className="flex max-w-[180px] items-center">
                    <img src={item} alt="indirect" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </article>
      </ContentLayout>
    </div>
  );
};

export default OurCommitments;
